import classNames from 'classnames/bind';
import { Formik, Form } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import Icon from 'uikit/Icon';
import Menu from 'uikit/Menu';
import Switch from 'uikit/Switch';
import Tooltip from 'uikit/Tooltip';

import CourseStudyModal from './CourseStudyModal';
import styles from './CourseStudy.module.scss';

const cx = classNames.bind(styles);

const CourseStudy = ({
  className,
  course,
  handleCourseStudy,
  handleModalClose,
  handleModalOpen,
  areOptionsOpen,
  isModalOpen,
  isTeacher,
  t,
  validationSchema,
}) => (
  <Formik
    initialValues={{
      wooflash: true,
      onlyNew: false,
      allRandom: false,
      inOrder: false,
    }}
    onSubmit={() => null}
    validationSchema={validationSchema}
  >
    {({ setFieldValue, setStatus, values }) => (
      <>
        <Form
          className={cx(
            'container',
            {
              isTeacher,
            },
            className,
          )}
        >
          <button
            className={cx('button')}
            onClick={
              course?.chapters.length > 0
                ? handleModalOpen
                : () => handleCourseStudy(null, setStatus, values)
            }
            type="button"
          >
            {t('Course/Shared/CourseStudy/study-course')}
          </button>
          {!course?.isLinear &&
          (course?.questions.length ||
            course?.chapters.filter((chapter) => !chapter.isLinked).length) >
            0 ? (
            <Menu
              isHideOnClickDeactivated
              placement={isTeacher ? 'bottom-end' : 'bottom'}
              toggle={
                <button
                  aria-label={t('Course/Shared/CourseStudy/options')}
                  className={cx('action', { areOptionsOpen })}
                  type="button"
                >
                  <Icon className={cx('icon')} name="cog" />
                </button>
              }
            >
              <div className={cx('options')}>
                <Switch
                  className={cx('switch')}
                  helper={
                    <Tooltip
                      tooltip={t(
                        'Course/Shared/CourseStudy/wooflash-method-helper',
                      )}
                    >
                      <Icon name="info-circle" />
                    </Tooltip>
                  }
                  name="wooflash"
                  label={t('Course/Shared/CourseStudy/wooflash')}
                  onChange={() =>
                    setFieldValue('wooflash', true) &&
                    setFieldValue('onlyNew', false) &&
                    setFieldValue('allRandom', false) &&
                    setFieldValue('inOrder', false)
                  }
                />
                <Switch
                  className={cx('switch')}
                  helper={
                    <Tooltip
                      tooltip={t(
                        'Course/Shared/CourseStudy/in-order-method-helper',
                      )}
                    >
                      <Icon name="info-circle" />
                    </Tooltip>
                  }
                  name="inOrder"
                  label={t('Course/Shared/CourseStudy/in-order')}
                  onChange={() =>
                    values.inOrder
                      ? setFieldValue('wooflash', true) &&
                        setFieldValue('onlyNew', false) &&
                        setFieldValue('allRandom', false) &&
                        setFieldValue('inOrder', false)
                      : setFieldValue('wooflash', false) &&
                        setFieldValue('onlyNew', false) &&
                        setFieldValue('allRandom', false) &&
                        setFieldValue('inOrder', true)
                  }
                />
                <Switch
                  className={cx('switch')}
                  name="allRandom"
                  label={t('Course/Shared/CourseStudy/random-order')}
                  onChange={() =>
                    values.allRandom
                      ? setFieldValue('wooflash', true) &&
                        setFieldValue('onlyNew', false) &&
                        setFieldValue('allRandom', false) &&
                        setFieldValue('inOrder', false)
                      : setFieldValue('wooflash', false) &&
                        setFieldValue('onlyNew', false) &&
                        setFieldValue('allRandom', true) &&
                        setFieldValue('inOrder', false)
                  }
                />
                <Switch
                  className={cx('switch')}
                  name="onlyNew"
                  label={t('Course/Shared/CourseStudy/new-only')}
                  onChange={() =>
                    values.onlyNew
                      ? setFieldValue('wooflash', true) &&
                        setFieldValue('onlyNew', false) &&
                        setFieldValue('allRandom', false) &&
                        setFieldValue('inOrder', false)
                      : setFieldValue('wooflash', false) &&
                        setFieldValue('onlyNew', true) &&
                        setFieldValue('allRandom', false) &&
                        setFieldValue('inOrder', false)
                  }
                />
                {course?.chapters.filter((chapter) => chapter.isLinked).length >
                  0 && (
                  <p className={cx('information')}>
                    {t(
                      'Course/Shared/CourseStudy/information-progressive-chapters',
                    )}
                  </p>
                )}
              </div>
            </Menu>
          ) : (
            !isTeacher && (
              <button
                className={cx('action')}
                onClick={
                  course?.chapters.length > 0
                    ? handleModalOpen
                    : () => handleCourseStudy(null, setStatus, values)
                }
                type="button"
                tabIndex="-1"
              >
                <Icon name="chevron-right" />
              </button>
            )
          )}
        </Form>
        <CourseStudyModal
          course={course}
          isModalOpen={isModalOpen}
          handleModalClose={handleModalClose}
          setStatus={setStatus}
          validationSchema={validationSchema}
          values={values}
          handleCourseStudy={(chapterId) =>
            handleCourseStudy(chapterId, setStatus, values)
          }
        />
      </>
    )}
  </Formik>
);

CourseStudy.propTypes = {
  className: PropTypes.string,
  course: PropTypes.object,
  handleCourseStudy: PropTypes.func.isRequired,
  handleModalOpen: PropTypes.func.isRequired,
  handleModalClose: PropTypes.func.isRequired,
  areOptionsOpen: PropTypes.bool.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  isTeacher: PropTypes.bool,
  t: PropTypes.func.isRequired,
  validationSchema: PropTypes.object.isRequired,
};

CourseStudy.defaultProps = {
  className: undefined,
  course: undefined,
  isTeacher: undefined,
};

export default CourseStudy;
